<template>
  <ConfirmDialog
    v-if="loginConfirmShow"
    :initOpen="true"
    :title="confirm.title"
    :content="confirm.message"
    :buttons="confirmDialogButtonConfig"
  />
</template>

<script>
  import { mapState } from "vuex";
  import ConfirmDialog from "@/components/Dialog/ConfirmDialog.vue";

  export default {
    name: 'LoginConfirmDialog',
    components: {
      ConfirmDialog
    },
    data() {
      return {
        confirm: {
          title: '',
          message: '請先登入會員'
        }
      }
    },
    computed: {
      ...mapState([
        "loginConfirmShow",
        "qcssoSdk"
      ]),
      confirmDialogButtonConfig() {
        return [
          {
            text: "取消",
            outline: true,
            click: () => {
              this.onCloseConfirmDialog();
            }
          },
          {
            text: "前往登入",
            click: () => {
              this.onCloseConfirmDialog();
              this.toLogin();
            }
          }
        ];
      }
    },
    methods: {
      onCloseConfirmDialog() {
        this.$store.commit('updateLoginConfirmShow', false);
      },
      toLogin() {
        const config = {
          redirectUrl: `${process.env.VUE_APP_HOST}${process.env.BASE_URL}${
            this.$route.query.redirectPath || ""
          }`,
        }
        this.$store.state.qcssoSdk.login(config);
      }
    }
  }
</script>